var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: _vm.isMobile ? 6 : 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("pleaseChoose")
                  },
                  on: { change: _vm.envIdChange },
                  model: {
                    value: _vm.paramsData.env_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "env_id", $$v)
                    },
                    expression: "paramsData.env_id"
                  }
                },
                _vm._l(_vm.szgmEnv, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.isMobile ? 6 : 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("serverChannel")
                  },
                  on: { change: _vm.serverChange },
                  model: {
                    value: _vm.server_channel,
                    callback: function($$v) {
                      _vm.server_channel = $$v
                    },
                    expression: "server_channel"
                  }
                },
                _vm._l(_vm.serverChannel, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.isMobile ? 6 : 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("showTestServer")
                  },
                  on: { change: _vm.serverChannelChange },
                  model: {
                    value: _vm.show_test,
                    callback: function($$v) {
                      _vm.show_test = $$v
                    },
                    expression: "show_test"
                  }
                },
                _vm._l(_vm.serverType, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function() {
                      _vm.list = []
                      _vm.serverChannelChange()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("refresh")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addserver.open(
                        null,
                        false,
                        _vm.serverChannel
                      )
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("add")) + " ")]
              ),
              _vm.serverListYJ.length
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.modifyData()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("batchModify")) + " ")]
                  )
                : _vm._e(),
              _vm.serverListYJ.length
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.mergeServers()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("mergeServers")) + " ")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.serverListYJ, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "serverName",
              label: _vm.$t("serverName"),
              "min-width": "160"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "invisible",
              label: _vm.$t("isVisible"),
              "min-width": "100"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.invisible == 1
                            ? _vm.$t("visible")
                            : _vm.$t("invisible")
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "serverID",
              label: _vm.$t("serverId"),
              "min-width": "100"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "areaID",
              label: _vm.$t("serverBelongArea"),
              "min-width": "160"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "serverIP",
              label: _vm.$t("serverIpAddress"),
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "serverPort",
              label: _vm.$t("serverPort"),
              "min-width": "130"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "new_tag",
              label: _vm.$t("isNewServer"),
              "min-width": "130"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(row.new_tag ? _vm.$t("yes") : _vm.$t("no")) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "is_test",
              label: _vm.$t("isTestServer"),
              "min-width": "130"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(row.is_test ? _vm.$t("yes") : _vm.$t("no")) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "is_recomm",
              label: _vm.$t("recommendServerTag"),
              "min-width": "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.recommList.find(function(i) {
                            return i.value == row.is_recomm
                          }).label
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "config_state",
              label: _vm.$t("configServerStatus"),
              "min-width": "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.configState.find(function(i) {
                            return i.value == row.config_state
                          }).label
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "role_count",
              label: _vm.$t("currentServerRegisteredPlayers"),
              "min-width": "190"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "push_msg",
              label: _vm.$t("serverPushMessage"),
              "min-width": "190",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-ellipsis-1" }, [
                      _vm._v(" " + _vm._s(row.push_msg || "/") + " ")
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "ver_max",
              label: _vm.$t("maxVersion"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "ver_min",
              label: _vm.$t("minVersion"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "openTimeFormat",
              label: _vm.$t("openServerTime"),
              "min-width": "260"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(row.openTimeFormat ? row.openTimeFormat : "/") +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operation"),
              "min-width": "70",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.addserver.open(row, true)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("modify")) + " ")]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("addserver", {
        ref: "addserver",
        attrs: { propsData: { env_id: _vm.paramsData.env_id } },
        on: { update: _vm.getList }
      }),
      _c("modify-batch-server", {
        ref: "modifyBatchServer",
        attrs: { propsData: { env_id: _vm.paramsData.env_id } },
        on: { update: _vm.getList }
      }),
      _c("merge-servers", {
        ref: "mergeServers",
        attrs: { propsData: { env_id: _vm.paramsData.env_id } },
        on: { update: _vm.getList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }